import * as React from 'react';
import HoldOrderPageView from '../layouts/HoldOrderPageView';
import { RowDataLive } from 'src/reducers/liveorderfile';
// import { UserDetail } from '../../reducers/user';

export interface HoldOrderPageViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    liveOrderDataOnHold: RowDataLive[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    submitRework: (column: Object) => void;
}

class HoldOrderPage extends React.Component<HoldOrderPageViewProps> {
    render() {
        return (
            <HoldOrderPageView
                onRowClick={this.props.onRowClick}
                liveOrderDataOnHold={this.props.liveOrderDataOnHold}
                reload={this.props.reload}
                onDownloadClick={this.props.onDownloadClick}
                submitRework={this.props.submitRework}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default HoldOrderPage;



// WEBPACK FOOTER //
// ./src/components/HoldOrderPage/HoldOrderPage.tsx